import { Action } from '@ngrx/store';
import {
    EMPLOYEES_SUGGESTIONS_FETCH,
    SETTINGS_FETCH,
    SETTINGS_FETCHING_SET,
    SETTINGS_SET,
    SETTINGS_UPDATE,
    SETTINGS_TIPS_SET } from '../action-types';
import { ObservableAction } from '../shared/actions/observable-action';
import { ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { GROUP_EMPLOYEE_SUGGESTIONS } from '../state-groups';
import { EMPLOYEE_ENTITY } from '../entity-types';
import { SharedAction } from '../shared/actions/shared-action';

export class FetchSettingsAction implements Action {
    readonly type = SETTINGS_FETCH;
}

export class SetSettingsAction implements Action {
    readonly type = SETTINGS_SET;

    constructor(public payload: { settings: any }) {}
}

export class SetFetchingSettingsAction implements Action {
    readonly type = SETTINGS_FETCHING_SET;

    constructor(public payload: boolean) {}
}

export class SetTipsAction implements Action {
    readonly type = SETTINGS_TIPS_SET;
}

@ObservableAction()
export class UpdateSettingsAction implements Action {
    readonly type = SETTINGS_UPDATE;

    constructor(public payload: { settings: any }) {}
}

export class FetchEmployeeSuggestionsAction implements Action {
    readonly type = EMPLOYEES_SUGGESTIONS_FETCH;

    constructor() {}
}

export class SetEmployeeSuggestionsAction extends ListSetAction implements Action {
    name = GROUP_EMPLOYEE_SUGGESTIONS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

export class SetEmployeeSuggestionsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_SUGGESTIONS;

    constructor(payload: any) {
        super(payload);
    }
}
